var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLarr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70711 11.7072L0 6.00007L5.70711 0.292969L7.12132 1.70718L3.82844 5.00006L17.4142 5.00006V7.00006L3.82841 7.00006L7.12132 10.293L5.70711 11.7072Z",
    fill: "#192337"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLarr);
export default __webpack_public_path__ + "static/media/larr.5f9f2d77.svg";
export { ForwardRef as ReactComponent };